export default {
    ROOT: 1,
    DEFAULT: 2,
    INTERNAL_REPORT: 3,
    SUPPORT: 4,
};
